import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=226d0edc&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=226d0edc&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d0edc",
  null
  
)

export default component.exports